import { LocationStrategy } from '@angular/common';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { filter } from 'rxjs';
import { AuthService, ScreenService, AppInfoService } from 'src/app/shared/services';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { TranslationService } from 'src/app/shared/services/i18n/translation.service';
import { PermissionAction, PermissionService } from 'src/app/shared/services/permission.service';
import { SignalRService } from 'src/app/signal-r.service';

@Component({
  selector: 'app-afairs-setting',
  templateUrl: './afairs-setting.component.html',
  styleUrls: ['./afairs-setting.component.scss']
})
export class AfairsSettingComponent implements OnInit {
  canAdd: any;
  canEdit: any;
  canDelete: any;
  @ViewChild('grid', { static: false }) grid: DxDataGridComponent;

  not: any;
  searchitems: any;
  currentRoute: string = '';
  constructor(private authService: AuthService, public route: ActivatedRoute, private url: LocationStrategy,
    private screen: ScreenService, public appInfo: AppInfoService, public router: Router,public gt:genericCustomStoreService,
    private translate: TranslateService,private signalrservice:SignalRService,public permissionService :PermissionService,public routee: ActivatedRoute,
    public translationService: TranslationService ,public cdRef: ChangeDetectorRef,public outlet:RouterOutlet,
    private activatedRoute: ActivatedRoute,
    private resolver: ComponentFactoryResolver) { }

    ngOnInit() {
      // this.router.events.pipe(
      //   filter(event => event instanceof NavigationEnd)
      // ).subscribe((event: NavigationEnd) => {
      //   this.currentRoute = event.urlAfterRedirects.startsWith('/')
      //     ? event.urlAfterRedirects.substring(1) // Remove leading slash
      //     : event.urlAfterRedirects;
        
      //   console.log('Current Route:', this.currentRoute);
      // });
       // Get the current route path
      this.router.events.pipe(
                filter(event => event instanceof NavigationEnd)
              ).subscribe((event: NavigationEnd) => {
                this.currentRoute = event.urlAfterRedirects.startsWith('/')
                  ? event.urlAfterRedirects.substring(1) // Remove leading slash
                  : event.urlAfterRedirects;
                
                console.log('Current Route:', this.currentRoute);
              });
       
        // Subscribe to NavigationEnd event to automatically refresh on route change
        this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.refreshRouterOutlet();
        }
      });
    
      
    }
  
isAuthenticated() {
      return this.authService.loggedIn;
    }
  
  
    // ngAfterViewInit() {
    //   setTimeout(() => {
    //     console.log('Grid available after delay:', this.grid);
    //     if (this.grid) {
    //       this.setupGridOptions();
    //     } else {
    //       console.log('Grid is still not available.');
    //     }
    //   });
    // }
    
    // setupGridOptions() {
    //   if (this.grid && this.grid.instance) {
    //     this.grid.instance.option('editing', {
    //       allowUpdating: false,
    //       allowAdding: true,
    //       allowDeleting: false
    //     });
    //   }
    // }
    refreshRouterOutlet() {
      console.log('Router outlet refreshed');
      this.onRouterOutletActivate(null);
    }
  
    onRouterOutletActivate(component: any) {
      console.log('Router outlet activated:', component);
      if (component) {
        this.applyGridPermissions(component);
      } else {
        console.log('No component to activate.');
      }
    }
  
    applyGridPermissions(component: any): boolean {
      if (!component) {
        console.warn('Component is undefined or null.');
        return false;
      }
  
      const gridKey = 'grid' as keyof typeof component;
  
      setTimeout(() => {
        const gridInstance = component[gridKey]?.instance;
      
        if (!gridInstance) {
          console.warn('Grid instance not found on component.');
          return;
        }
      
        const { allowAdding, allowUpdating, allowDeleting } = this.gt.getPermissionsForRoute(this.currentRoute);
      
        gridInstance.option('editing', {
          allowAdding,
          allowUpdating,
          allowDeleting
        });
        console.log('Applying permissions:', { allowAdding, allowUpdating, allowDeleting });
  
        console.log('Grid permissions applied successfully.');
      }, 0);
      
      return true;
    }
    hasPermission(permissions: PermissionAction[], permissionName: string): boolean {
      return permissions.some(p => p.name === permissionName && p.isAvailable);
    }
    
  
}
